import { apiUrl } from "../ApiManager/AxiosHeaders";

export function mapProviderContractToDocument(contract = {}) {
  const label = contract.document_name || contract.name || "Document";
  return {
    id: contract.id,
    type: "provider_contract",
    name: label,
    document_name: label,
    url: contract.url || contract.file_url || contract.file_path || "",
    app_type: contract.status
      ? String(contract.status).replace(/^\w/, (c) => c.toUpperCase())
      : undefined,
  };
}

export function mapProviderContractsToDocuments(contracts = []) {
  if (!Array.isArray(contracts)) return [];
  return contracts
    .map(mapProviderContractToDocument)
    .filter((doc) => doc && (doc.url || doc.name || doc.document_name));
}

export async function fetchProviderDocuments(providerId) {
  if (!providerId) return [];
  try {
    const response = await apiUrl.get(`get-provider-contracts/${providerId}`);
    const contracts =
      response?.data?.status && Array.isArray(response?.data?.data)
        ? response.data.data
        : [];
    return mapProviderContractsToDocuments(contracts);
  } catch {
    return [];
  }
}

// Must not exceed BULK_PROVIDER_CONTRACTS_MAX_IDS in ProvidersController.
const BULK_CONTRACTS_CHUNK_SIZE = 200;

async function fetchProviderContractsBulk(providerIds) {
  const contractsByProvider = {};
  for (let i = 0; i < providerIds.length; i += BULK_CONTRACTS_CHUNK_SIZE) {
    const chunk = providerIds.slice(i, i + BULK_CONTRACTS_CHUNK_SIZE);
    try {
      const response = await apiUrl.get("get-provider-contracts", {
        params: { provider_ids: chunk.join(",") },
      });
      if (response?.data?.status && response?.data?.data) {
        Object.assign(contractsByProvider, response.data.data);
      }
    } catch {
      // Providers in a failed chunk render with no documents.
    }
  }
  return contractsByProvider;
}

export async function enrichProvidersWithDocuments(providers = []) {
  if (!Array.isArray(providers) || !providers.length) {
    return [];
  }

  const providerIds = [
    ...new Set(providers.map((provider) => provider?.id).filter(Boolean)),
  ];
  const contractsByProvider = providerIds.length
    ? await fetchProviderContractsBulk(providerIds)
    : {};

  return providers.map((provider) => ({
    ...provider,
    documents: mapProviderContractsToDocuments(
      contractsByProvider[provider?.id] || [],
    ),
  }));
}
